"use client";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import useFetchApi from "@/hooks/useFetchApi";
import { MainContext } from "@/contexts/MainContext";
const FooterComponent = ({ menuItems, aboutUs, services }) => {
  const pathname = usePathname();
  const router = useRouter();
  if (pathname.includes("login") || pathname.includes("register")) {
    return <></>;
  }

  // Ẩn "Dự án" khỏi danh sách Liên kết (giống Header)
  const footerMenuItems = (menuItems || []).filter(
    (item) => item.slug !== "/du-an" && item.label !== "Dự án"
  );

  return (
    <div className="bg-[#0C1B56] text-white overflow-hidden">
      <div className="flex flex-col section relative px-4 sm:px-6 md:px-8">
        <div className="z-10 text-white grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 lg:gap-[72px] py-10 sm:py-12 md:py-14 lg:py-[60px]">
          <div className="sm:col-span-2 lg:col-span-1">
            <img src={"/images/hitech.png"} alt="logo" className="h-8 sm:h-9 md:h-10 w-auto object-contain" />
            <p className="mt-4 sm:mt-6 md:mt-[28px] !text-sm sm:!text-base max-w-xs">
              Đối tác tin cậy trong lĩnh vực Tài chính - Ngân hàng - Fintech tại thị trường Việt Nam
            </p>
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-semibold mb-3 sm:mb-5 uppercase">Liên kết</h2>
            <div className="flex flex-col">
              {footerMenuItems.map((menuItem, i) => (
                <Link
                  href={menuItem.link || menuItem.slug}
                  key={`menuItem-${menuItem.link || menuItem.slug}-${i}`}
                  className="py-[5px] text-base text-[#ced1dd] font-semibold hover:text-white"
                >
                  {menuItem.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-semibold mb-3 sm:mb-5 uppercase">Dịch vụ</h2>
            <div className="flex flex-col">
              {services.map((service, i) => (
                <Link
                  href={`/dich-vu#${service.slug}`}
                  key={`service-${service.slug}-${i}`}
                  className="py-[5px] text-base text-[#ced1dd] font-semibold hover:text-white"
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-semibold mb-3 sm:mb-5 uppercase">
              Thông tin liên hệ
            </h2>
            <div className="flex flex-col">
              <div className="text-[#ced1dd] text-base font-normal gap-4 flex flex-col">
                <p>{aboutUs?.diaChi || ""}</p>
                <p>{aboutUs?.soDienThoai || ""}</p>
                <p>{aboutUs?.email || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 sm:mt-10 md:mt-12 lg:mt-[65px] section text-sm sm:text-base md:text-[17px] leading-relaxed px-4 sm:px-6 md:px-8 pb-6">
        <p>Copyright © 2026 Hi-Tech All rights reserved.</p>
      </div>
    </div>
  );
};

export default FooterComponent;
